const AppBreadcrumb = (props: any) => {
    let label = props?.meta?.label;
    return <span>{label}</span>;
};

export default AppBreadcrumb;
